import { AppPreviewActions } from '.'
import { InterpolationListProps } from '..'

export interface UpdateFollowStep1DataPayload {
    taskTitle?: string
    stepTitle?: string
    title?: string
    description?: string
    urlBlockTitle?: string
    mediaBlockMaxPhotos?: number
    follow_platform?: string
    brand_name?: string
}

interface UpdateFollowInterpolationListDataPayload {
    description: InterpolationListProps
}

export const updateFollowStep1Data = (payload: UpdateFollowStep1DataPayload) => ({
    payload,
    type: AppPreviewActions.UPDATE_FOLLOW_STEP1_DATA,
})

export const updateFollowInterpolationListData = (payload: UpdateFollowInterpolationListDataPayload) => ({
    payload,
    type: AppPreviewActions.UPDATE_FOLLOW_PLACEHOLDER_DATA,
})
